export class UnsupportedProduct extends Error {
    constructor(resolvedProduct) {
        super(resolvedProduct == null ? 'Product is unknown' : `Unsupported product '${resolvedProduct}'`);
        this.name = 'UnsupportedProduct';
    }
}
export class ProductParsingError extends Error {
    constructor(productName, msg) {
        super(`Error parsing product name: '${productName}' - ${msg}`);
        this.name = 'ProductParsingError';
    }
}
